import { IListaPaginada } from '../interfaces';

export class ListaPaginada<T = unknown> implements IListaPaginada<T> {
  totalDeItens: number = 0;
  itensPorPagina: number = 5;
  paginaAtual: number = 1;
  totalDePaginas: number = 0;
  temPaginaAnterior: boolean = false;
  temPaginaSeguinte: boolean = false;
  registros: T[] = [];
}
